<script setup>
import LaisPrimaryButton from './LaisPrimaryButton.vue';

defineProps({
  type: {
    type: String,
    default: 'empty',
    validator: value => ['empty', 'error', 'success'].includes(value),
  },
  title: { type: String, required: true },
  description: { type: String, default: '' },
  actionLabel: { type: String, default: '' },
  icon: { type: String, default: '' },
});

const emit = defineEmits(['action']);

const iconFor = type =>
  ({
    empty: 'i-lucide-search-x',
    error: 'i-lucide-circle-alert',
    success: 'i-lucide-circle-check',
  })[type];

const colorFor = type =>
  ({
    empty: 'text-lais-text-muted bg-lais-bg-muted',
    error: 'text-rose-700 bg-rose-50',
    success: 'text-emerald-700 bg-emerald-50',
  })[type];
</script>

<template>
  <section
    class="flex min-h-[260px] flex-col items-center justify-center rounded-lais border border-lais-border-soft bg-white px-6 py-10 text-center shadow-lais-card"
    role="status"
  >
    <span
      class="grid size-12 place-items-center rounded-full"
      :class="colorFor(type)"
      aria-hidden="true"
    >
      <span class="size-6" :class="icon || iconFor(type)" />
    </span>
    <h2 class="mt-4 text-lais-heading-sm font-semibold text-lais-text">
      {{ title }}
    </h2>
    <p
      v-if="description"
      class="mt-2 max-w-xl text-lais-body-sm text-lais-text-muted"
    >
      {{ description }}
    </p>
    <LaisPrimaryButton
      v-if="actionLabel"
      class="mt-5"
      variant="ghost"
      size="sm"
      :icon="type === 'error' ? 'i-lucide-refresh-cw' : 'i-lucide-arrow-right'"
      @click="emit('action')"
    >
      {{ actionLabel }}
    </LaisPrimaryButton>
    <slot />
  </section>
</template>
